import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const ProfileGroupPermissionGate = (props: Omit<BasePermissionGateProps<"profile">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="profile"
		/>
	)
}

export default ProfileGroupPermissionGate
